import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { BasePlugin } from '../base-plugin.component';
import { Inspection, ActionPlanModel, ActionPlanPlugin, Icon, Icons } from '../../shared/models/index';
import { ActivatedRoute } from '@angular/router';
import { PluginComponent } from '../plugin.component';
import { DiscussionPluginService } from './discussion-plugin.service';
import { PeopleService } from '../../shared/services';
import { Person } from '../../shared/models';

@Component({
    templateUrl: './discussion.component.html',
    standalone: false
})
export class DiscussionPluginComponent extends BasePlugin implements OnInit {
  public plugin: any = {};
  inspectionId: string;
  public inspection: Inspection | ActionPlanModel;
  public comments: any;
  public currentPerson: Person;

  constructor(
    private route: ActivatedRoute,
    private cdRef: ChangeDetectorRef,
    private service: DiscussionPluginService,
    public peopleService: PeopleService
  ) {
    super();
  }

  ngOnInit() {}
  config(
    plugin: any,
    inspection: Inspection | ActionPlanModel,
    messages: Array<string>,
    showBreadcrumbs: boolean,
    showValidations: boolean,
    showContent: boolean
  ): void {
    this.peopleService.getCurrent().subscribe((data) => (this.currentPerson = data));
    this.plugin = plugin;
    this.showBreadcrumbs = showBreadcrumbs;
    this.showContent = showContent;
    this.showValidations = showValidations;
    this.messages = messages;

    this.comments = this.plugin.config.Comments;
    this.inspection = inspection;
    this.cdRef.detectChanges();
  }

  getEditRoute(comment: any) {
    return [
      this.actionPlansRoute,
      this.plugin.actionPlanId,
      'actionplanitems',
      this.plugin.actionPlanItemId,
      'plugins',
      this.plugin.id,
      'discussion',
      comment.Id,
      'edit'
    ];
  }

  getAddRoute() {
    return [
      this.actionPlansRoute,
      this.plugin.actionPlanId,
      'actionplanitems',
      this.plugin.actionPlanItemId,
      'plugins',
      this.plugin.id,
      'discussion',
      'add'
    ];
  }
}

PluginComponent.plugins['discussion'] = DiscussionPluginComponent;
PluginComponent.initializers['discussion'] = (plugin: ActionPlanPlugin) => {
  if (plugin.config && plugin.config && plugin.config.Comments && plugin.config.Comments.length > 0) {
    const actionPlanItem = plugin.actionPlan.actionPlanItems.find((a) => a.id === plugin.actionPlanItemId);
    const actionPlan = plugin.actionPlan;
    if (actionPlanItem) {
      const iconName = 'comment';
      const iconClasses = 'comment';
      var icon = new Icon(iconName, iconClasses, 0, Icons.discussionOrder);

      if (!actionPlanItem.icons.some((i) => i.name === iconName && i.classes === iconClasses)) {
        actionPlanItem.icons.push(icon);
      }

      if (actionPlan.responsibleList && actionPlan.responsibleList[actionPlanItem.responsible]) {
        const responsible = actionPlan.responsibleList[actionPlanItem.responsible];
        if (responsible.icons.some((i) => i.name === iconName && i.classes === iconClasses)) {
          const icon = responsible.icons.find((i) => i.name === iconName && i.classes === iconClasses);
          icon.count++;
        } else {
          icon.count = 1;
          responsible.icons.push(icon);
        }
      }
    }
  }
};
